import { CLUSTERS } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  segments: [],
  clustering: undefined,
  fetchSegmentsStatus: undefined,
  saveClusteringStatus: undefined,
  editClusterStatus: undefined,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CLUSTERS.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case CLUSTERS.FETCH_SEGMENTS:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.STARTED,
      };
    case CLUSTERS.FETCH_SEGMENTS_SUCCEEDED:
      return {
        ...state,
        segments: action.payload,
        fetchSegmentsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLUSTERS.FETCH_SEGMENTS_FAILED:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.FAILED,
      };
    case CLUSTERS.SAVE_CLUSTERING:
      return {
        ...state,
        saveClusteringStatus: CONSTANTS.API.STARTED,
      };
    case CLUSTERS.SAVE_CLUSTERING_SUCCEEDED:
      return {
        ...state,
        saveClusteringStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLUSTERS.SAVE_CLUSTERING_FAILED:
      return {
        ...state,
        saveClusteringStatus: CONSTANTS.API.FAILED,
      };
    case CLUSTERS.EDIT_CLUSTER:
      return {
        ...state,
        editClusterStatus: CONSTANTS.API.STARTED,
      };
    case CLUSTERS.EDIT_CLUSTER_SUCCEEDED:
      return {
        ...state,
        segments:
          state.segments.length === 1
            ? [
                {
                  ...state.segments[0],
                  clusters: state.segments[0].clusters.map((cluster) =>
                    cluster.id === action.payload.id ? { ...cluster, ...action.payload.payload } : cluster
                  ),
                },
              ]
            : state.segments,
        editClusterStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLUSTERS.EDIT_CLUSTER_FAILED:
      return {
        ...state,
        editClusterStatus: CONSTANTS.API.FAILED,
      };

    case CLUSTERS.SET_CLUSTERING:
      return {
        ...state,
        clustering: action.payload,
      };
    default:
      return state;
  }
};
